module.exports = __webpack_public_path__ + "img/help9.dc0bd62a.png";